import React, { createContext, useContext } from 'react';
import { notification } from 'antd';
import type { NotificationInstance } from 'antd/es/notification/interface';

interface NotificationContextType {
  notify: NotificationInstance;
  contextHolder: React.ReactNode;
}

const NotificationContext = createContext<NotificationContextType | null>(null);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [api, contextHolder] = notification.useNotification();

  return (
    <NotificationContext.Provider value={{ notify: api, contextHolder }}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifier = () => {
  const context = useContext(NotificationContext);
  if (!context)
    throw new Error('useNotifier must be used within a NotificationProvider');
  return context.notify;
};
